import { useEffect, useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { getPromoData } from '@hungryroot/rest/api/get_promo_data/get';

export function useGetPromoData() {
  const [isMounted, setIsMounted] = useState(false);

  useEffect(() => {
    setIsMounted(true);
  }, []);

  const query = useQuery({
    queryKey: ['promo_data', 'homepage'],
    queryFn: async () => {
      const resp = await getPromoData({
        page: 'homepage',
      });

      if (resp.status !== 200) {
        throw resp.data;
      }

      return resp.data;
    },
  });

  if (isMounted === false) {
    return {
      data: undefined,
    };
  }

  return query;
}
